
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { EditStoreProps } from '@/main/store/@types/edit.d';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME, CRUMB_LABEL, POLOZKY, ND_PRIJEMKA, X_VYROBEKND_OZN, X_SKLAD_OZN, POZNAMKA, X_SKLADMISTO_ID, TEXT } from '../constants';
import { apiProvider } from '../api';

const edit = {
	EdlId: null as number | null,
	VyrobekndOzn: null as String | null,
	MioPzn: null as number | null,
	MiozahlaviId: null as number | null,
	DodListNr: null as String | null,
	ObchodnikNr: null as String | null,
	ObjednPuvodce: null as String | null,
	VstupDat: null as Date | null,
	XVyrobekndOzn: null as String | null,
	XMioPzn: null as String | null,
	XMioNr: null as String | null,
	ObjednavkaDat: null as Date | null,
	XObjednPzn: null as String | null,
	EdlPriznak: null as String | null,
	Polozky: null as [] | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL,
	dropdownList: {
		MioPzn: [] as DropdownItem[],
		VyrobekndOzn: [] as DropdownItem[],
		SkladOzn: [] as DropdownItem[],
	},
	depTableNames: [POLOZKY, ND_PRIJEMKA],
	depTableSettings: {
		[POLOZKY]: {
			filter(state) {
				return { zakzalohaId: state.props.id };
			},
			loadByEntityId: false,
			isEditable: true,
			columns: {
				[X_VYROBEKND_OZN]: { isEditable: true },
				[X_SKLAD_OZN]: { isEditable: true },
				[X_SKLADMISTO_ID]: { isEditable: true },
				[TEXT]: { isEditable: true },
				[POZNAMKA]: { isEditable: true },
			},
		},
		[ND_PRIJEMKA]: {
			loadByEntityId: true,
			filter(state) {
				return { EdlId: state.props.id };
			},
		},
	},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	} as EditStoreProps,
});
